var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconExplore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 80,
    viewBox: "0 0 74 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Custom Icons",
    clipPath: "url(#clip0_1095_10892)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M68.0121 17.4733C68.0121 17.4733 68.0121 17.3843 67.9748 17.3487C67.9188 17.1886 67.8442 17.0463 67.7136 16.9395L47.3809 0.213513C47.269 0.106752 47.1197 0.053371 46.9519 0.0355774C46.9146 0.0355774 46.8772 0.0355774 46.8586 0.0355774C46.8213 0.0355774 46.8026 0.0355774 46.7653 0.0355774H5.18578C2.33174 -9.75654e-06 0 2.22419 0 4.94661V69.3238C0 72.0463 2.33174 74.2705 5.18578 74.2705H49.6194C50.1417 74.2705 50.5521 73.879 50.5521 73.3808C50.5521 72.8826 50.1417 72.4911 49.6194 72.4911H5.18578C3.3577 72.4911 1.86539 71.0676 1.86539 69.3238V4.94661C1.86539 3.20284 3.3577 1.77935 5.18578 1.77935H45.8326V17.6334C45.8326 18.1317 46.243 18.5231 46.7653 18.5231H66.184V55.9964C66.184 56.4947 66.5944 56.8861 67.1167 56.8861C67.639 56.8861 68.0494 56.4947 68.0494 55.9964V17.6334C68.0494 17.6334 68.0308 17.5445 68.0121 17.4911V17.4733ZM47.698 2.82917L50.4588 5.10675L64.5984 16.7438H47.698V2.82917Z",
    fill: "#192C62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M30.1634 46.459H8.5435C6.96725 46.459 5.68945 47.6779 5.68945 49.1814V49.1992C5.68945 50.7027 6.96725 51.9216 8.5435 51.9216H30.1634C31.7396 51.9216 33.0174 50.7027 33.0174 49.1992V49.1814C33.0174 47.6779 31.7396 46.459 30.1634 46.459Z",
    fill: "#1696E5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M30.1634 59.4131H8.5435C6.96725 59.4131 5.68945 60.632 5.68945 62.1355V62.1533C5.68945 63.6569 6.96725 64.8757 8.5435 64.8757H30.1634C31.7396 64.8757 33.0174 63.6569 33.0174 62.1533V62.1355C33.0174 60.632 31.7396 59.4131 30.1634 59.4131Z",
    fill: "#1696E5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M38.912 7.63379H8.5435C6.96725 7.63379 5.68945 8.85266 5.68945 10.3562V10.374C5.68945 11.8776 6.96725 13.0964 8.5435 13.0964H38.912C40.4883 13.0964 41.7661 11.8776 41.7661 10.374V10.3562C41.7661 8.85266 40.4883 7.63379 38.912 7.63379Z",
    fill: "#FFBA00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M59.4873 20.5869H8.5435C6.96725 20.5869 5.68945 21.8058 5.68945 23.3093V23.3271C5.68945 24.8307 6.96725 26.0495 8.5435 26.0495H59.4873C61.0635 26.0495 62.3413 24.8307 62.3413 23.3271V23.3093C62.3413 21.8058 61.0635 20.5869 59.4873 20.5869Z",
    fill: "#1696E5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M59.4873 33.5234H8.5435C6.96725 33.5234 5.68945 34.7423 5.68945 36.2459V36.2636C5.68945 37.7672 6.96725 38.9861 8.5435 38.9861H59.4873C61.0635 38.9861 62.3413 37.7672 62.3413 36.2636V36.2459C62.3413 34.7423 61.0635 33.5234 59.4873 33.5234Z",
    fill: "#1696E5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M55.2754 67.0928L60.4724 62.1355L72.9108 74.0003C74.3486 75.3717 74.3486 77.5861 72.9108 78.9576C71.4731 80.329 69.1516 80.329 67.7138 78.9576L55.2754 67.0928Z",
    fill: "#00C880"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M49.601 69.021C42.0649 69.021 35.9277 63.1669 35.9277 55.9783C35.9277 48.7896 42.0649 42.9355 49.601 42.9355C57.1372 42.9355 63.2743 48.7896 63.2743 55.9783C63.2743 63.1669 57.1372 69.021 49.601 69.021ZM49.601 44.7149C43.0908 44.7149 37.7931 49.7683 37.7931 55.9783C37.7931 62.1882 43.0908 67.2416 49.601 67.2416C56.1112 67.2416 61.409 62.1882 61.409 55.9783C61.409 49.7683 56.1112 44.7149 49.601 44.7149Z",
    fill: "#192C62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M40.2921 56.8685C39.7698 56.8685 39.3594 56.4771 39.3594 55.9789C39.3594 50.5874 43.9669 46.1924 49.619 46.1924C50.1413 46.1924 50.5517 46.5838 50.5517 47.0821C50.5517 47.5803 50.1413 47.9717 49.619 47.9717C44.9929 47.9717 41.2248 51.566 41.2248 55.9789C41.2248 56.4771 40.8144 56.8685 40.2921 56.8685Z",
    fill: "#192C62"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1095_10892"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExplore);
export default __webpack_public_path__ + "static/media/icon-explore.9210a77a77ae840fafd38b502535ae64.svg";
export { ForwardRef as ReactComponent };